import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";

export default function HRPage() {
  const [faculty, setFaculty] = useState([]);
  useEffect(()=>{ api.get("/faculty").then(({data})=>setFaculty(data)); },[]);

  const payroll = faculty.reduce((s,f)=>s+Number(f.salary||0), 0);

  return (
    <div>
      <PageHeader title="HR & Payroll" subtitle="Staff management, payroll, leave" />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="linkedin-card p-4" data-testid="hr-employees-card">
          <div className="kpi-label">Total Employees</div>
          <div className="text-2xl font-semibold mt-1">{faculty.length}</div>
        </div>
        <div className="linkedin-card p-4" data-testid="hr-payroll-card">
          <div className="kpi-label">Monthly Payroll</div>
          <div className="text-2xl font-semibold text-[#0A66C2] mt-1">₹{payroll.toLocaleString('en-IN')}</div>
        </div>
        <div className="linkedin-card p-4" data-testid="hr-leaves-card">
          <div className="kpi-label">On Leave</div>
          <div className="text-2xl font-semibold text-[#915907] mt-1">0</div>
        </div>
      </div>
      <DataTable
        testid="hr-table"
        columns={[
          { key:"name", label:"Employee" },
          { key:"subject", label:"Role/Subject" },
          { key:"qualification", label:"Qualification" },
          { key:"joining_date", label:"Joined" },
          { key:"salary", label:"Salary", render: r => `₹${(r.salary||0).toLocaleString('en-IN')}` },
        ]}
        rows={faculty}
      />
    </div>
  );
}
